<template>
  <b-pagination
    v-model="currentPage"
    :total-rows="filteredCount"
    :per-page="pageSize"
    first-text="First"
    prev-text="Prev"
    next-text="Next"
    last-text="Last"
  />
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    onPageChanged: {
      type: Function,
    },
    filteredCount: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  watch: {
    page(p) {
      // if our prop changes, sync it here
      if (p !== this.currentPage) {
        this.currentPage = p;
      }
    },
    currentPage(p) {
      this.onPageChanged(p);
    },
  },
  mounted() {
    // bind control to currentPage and watch it to set page
    this.currentPage = this.page;
  },
};
</script>

<style lang="scss" scoped>
</style>
